import script from "./ComingSoonSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoonSection.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoonSection.vue?vue&type=style&index=0&id=3c4b2226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4b2226"]])

export default __exports__